import React from 'react';
import { useLang } from '../../contexts/LangContext';
import { buildingsApi, Building } from '../../api/buildingsApi';
import { LogoPathField } from '../common/LogoPathField';

interface BuildingLogoFieldProps {
  logoPath: string;
  onLogoPathChange: (logoPath: string) => void;
  buildingId?: string;
  operatorId?: string;
  uploadDisabled?: boolean;
}

export const BuildingLogoField: React.FC<BuildingLogoFieldProps> = ({
  logoPath,
  onLogoPathChange,
  buildingId,
  operatorId,
  uploadDisabled = false,
}) => {
  const { t } = useLang();

  const handleUpload = async (file: File) => {
    if (buildingId) {
      const updated: Building = await buildingsApi.uploadBuildingLogo(buildingId, file);
      onLogoPathChange(updated.logoPath || '');
      return;
    }
    const result = await buildingsApi.uploadBuildingLogoFile(file, operatorId);
    onLogoPathChange(result.logoPath);
  };

  const handleRemove = async () => {
    if (buildingId) {
      const updated = await buildingsApi.removeBuildingLogo(buildingId);
      onLogoPathChange(updated.logoPath || '');
      return;
    }
    onLogoPathChange('');
  };

  return (
    <LogoPathField
      logoPath={logoPath}
      onLogoPathChange={onLogoPathChange}
      label={t('buildingLogoPath')}
      pathHint={t('buildingLogoPathHint')}
      placeholder={t('enterBuildingLogoPath')}
      onUpload={handleUpload}
      onRemove={handleRemove}
      uploadDisabled={uploadDisabled}
      confirmRemove={Boolean(buildingId)}
    />
  );
};
